<template>
  <div id="contact-detail" v-if="detail.id !== ''">
    <table class="unstriped">
      <tbody>
      <tr>
        <td>{{ 'Contact ID'|t }}:</td>
        <td>{{ detail.contactid }}</td>
      </tr>
      <tr>
        <td>{{ 'Status'|t }}:</td>
        <td v-html="detail.status.join('<br>')"></td>
      </tr>
      <tr>
        <td>{{ 'Registrar'|t }}:</td>
        <td><RouteLabelConverter v-bind="registrarProps()"></RouteLabelConverter></td>
      </tr>
      <tr>
        <td>{{ 'Created'|t }}:</td>
        <td>{{ detail.created_at|date }}</td>
      </tr>
      <tr>
        <td>{{ 'Updated'|t }}:</td>
        <td>{{ detail.updated_at|date }}</td>
      </tr>
      <tr>
        <td>{{ 'IDNum'|t }}:</td>
        <td>{{ detail.idnum }}</td>
      </tr>
      <tr>
        <td>{{ 'VAT'|t }}:</td>
        <td>{{ detail.vat }}</td>
      </tr>
      <tr>
        <td>{{ 'Authentication information'|t }}:</td>
        <td><i class="icon icon-eye hover-help" :title="detail.authinfo"></i></td>
      </tr>
      <tr>
        <td>{{ 'Birth date'|t }}:</td>
        <td>{{ detail.birthdate|date('date') }}</td>
      </tr>
      <tr>
        <td>{{ 'Address'|t }}:</td>
        <td>
          <a :href="gmapLink(detail)" target="_blank">
            <address>
              {{ detail.name }},
              {{ detail.org }},
              {{ detail.street }},
              {{ detail.postcode }} {{ detail.city }},
              {{ detail.state }},
              {{ detail.country }}
            </address>
          </a>
        </td>
      </tr>
      <tr>
        <td>{{ 'Disclose'|t }}:</td>
        <td v-html="detail.disclose.split(',').join('<br>')"></td>
      </tr>
      <tr>
        <td>{{ 'E-mail address'|t }}:</td>
        <td><a :href="'mailto:' + detail.email">{{ detail.email }}</a></td>
      </tr>
      <tr>
        <td>{{ 'Telephone'|t }}:</td>
        <td><a :href="'tel:' + clearPhone(detail.phone)">{{ detail.phone }}</a></td>
      </tr>
      <tr>
        <td>{{ 'Fax'|t }}:</td>
        <td>{{ detail.fax }}</td>
      </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
  import api from '@/api';
  import RouteLabelConverter from '@/components/RouteLabelConverter';

  export default {
    name: 'Detail',
    components: { RouteLabelConverter },
    props: {
      id: {
        type: String,
        required: true
      }
    },
    data() {
      return {
        detail: {
          id: ""
        }
      }
    },
    created() {
      api.viewContact(
        {contact_id: this.id},
        data => this.detail = data
      )
    },
    methods: {
      clearPhone(num) {
        let cp = num;
        return cp.replace('.', '')
      },
      gmapLink(subject) {
        let q = subject.org + ", " + subject.street + ", " + subject.postcode + " " + subject.city + ", " + subject.state + ", " + subject.country;
        return 'https://www.google.com/maps/search/' + q;
      },
      registrarProps() {
        return {
          request: {registrar_id: this.detail.registrar},
          placeholder: this.detail.registrar,
          call: "viewRegistrar",
          handler: function(data) {
            return data.name + ", " + data.org;
          },
          route: {
            to: {
              name: "registrar.view",
              params: {
                id: this.detail.registrar,
              },
            },
          }
        };
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/contact/Detail.vue